import axios, { AxiosRequestConfig } from "axios";
import { Observable } from "rxjs";

const observableHandler = {
  get: function (target: any, prop: any, receiver: any) {
    if (typeof target[prop] === "function") {
      return function (...args: any[]) {
        return new Observable((observer) => {
          target[prop](...args)
            .then((response: { data: any }) => {
              observer.next(response.data);
              observer.complete();
            })
            .catch((error: Error) => {
              observer.error(error);
            });
        });
      };
    }
    return target[prop];
  },
};

export interface ObservableAxios {
  get<T=any>(url: string, config?: AxiosRequestConfig<any>): Observable<T>;
  put<T=any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any>
  ): Observable<T>;
  post<T=any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any>
  ): Observable<T>;
  delete<T=any>(
    url: string,
    config?: AxiosRequestConfig<any>
  ): Observable<T>;
}


export const observableAxios: ObservableAxios = new Proxy(
  axios,
  observableHandler
);